import { IBaseResponseData, IMember } from '../index.js'

/**
 * This interface defines the object that is returned by the Congress API when
 * you request a list of members from the `/member` endpoint.
 */
export interface IMemberResponse extends IBaseResponseData {
  members: IMember[]
}
